export let BUILD_NUMBER = '';
BUILD_NUMBER = 'v2023.12.04.02.prod';
BUILD_NUMBER = "v2024.11.20.01.prod"
